import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import VehicleList from "../components/VehicleList";
import SparePartsList from "../components/SparePartsList";
import { sanityClient } from "../lib/sanityClient";
import { Helmet } from "react-helmet-async";

const CategoryPage = () => {
  const { slug, lang } = useParams(); // get lang from route
  const [category, setCategory] = useState(null);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const getLocalizedText = (field) => field?.[lang] || field?.en || "—";

  useEffect(() => {
    if (!slug) {
      setLoading(false);
      return;
    }

    const fetchCategoryData = async () => {
      try {
        // Fetch category document
        const categoryQuery = `*[_type == "category" && slug.current == $slug][0]`;
        const fetchedCategory = await sanityClient.fetch(categoryQuery, { slug });

        if (!fetchedCategory) {
          setLoading(false);
          return;
        }

        setCategory(fetchedCategory);

        let query = "";
        if (slug === "used-cars" || slug === "brand-new-cars") {
          query = `*[_type == "vehicle" && $categoryId in categories[]._ref]{
            _id, title, slug, price, condition, brand, model, year, primaryImage, categories[]->{slug}
          }`;
        } else if (slug === "spare-parts") {
          query = `*[_type == "sparePart" && $categoryId in categories[]._ref]{
            _id, name, slug, price, description, compatibility, primaryImage, categories[]->{slug}
          }`;
        }

        if (query) {
          const fetchedItems = await sanityClient.fetch(query, {
            categoryId: fetchedCategory._id,
          });
          setItems(fetchedItems);
        }
      } catch (error) {
        console.error("Error fetching category data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCategoryData();
  }, [slug, lang]);

  if (loading) {
    return <div className="text-center mt-8">Loading...</div>;
  }

  const localizedTitle = getLocalizedText(category?.title);
  const localizedDescription = getLocalizedText(category?.description);

  return (
    <div className="category-page container mx-auto px-4 py-8">
      <Helmet>
        <title>{localizedTitle}</title>
        <meta name="description" content={localizedDescription} />
      </Helmet>

      <div className="text-center mb-8">
        <h1 className="text-4xl font-bold">{localizedTitle || "Category Not Found"}</h1>
        <p className="text-lg text-gray-600 mt-2">
          {localizedDescription || "No details available."}
        </p>
      </div>

      <div>
        {slug === "used-cars" || slug === "brand-new-cars" ? (
          <VehicleList categorySlug={slug} />
        ) : slug === "spare-parts" ? (
          <SparePartsList spareParts={items} />
        ) : (
          <p className="text-center text-gray-500">No items available for this category.</p>
        )}
      </div>
    </div>
  );
};

export default CategoryPage;
